import TrialBalance from "./TrialBalance";

const TrialBalanceConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/trial-balance',
            element: <TrialBalance />,
        },
    ],
}

export default TrialBalanceConfig;